import { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';
import { StyledTableCellWithoutLeftRight } from 'routes/Main/style';
import Form from 'components/Form';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';

const contentLabel = [
  {
    id: 1,
    desc: ['수술: 개두술, 개흉술, 개복술에 한함(수술 당일 포함 3일간)'],
    scores: [1],
    ids: [1],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const Contents4 = (props: Props) => {
  const { palette } = useTheme();
  const { disabled, setValue, getValues, register } = props;

  const min = 0;
  const max = 5;

  const [input1, setInput1] = useState(
    getValues('no05_01') ? Number(getValues('no05_01')) : 0
  );

  return (
    <>
      <SectionTitle
        title="5. 측정항목 - C항목.환자특성(코드번호로 기재)"
        mb={3}
        mt={3}
      />
      <Box sx={{ width: '98%', margin: '20px auto' }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCellWithoutLeftRight
                align="left"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                항목
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeftRight
                align="center"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    marginLeft: '-15px',
                  }}
                >
                  0: 적용기준 해당없음 <br />
                  1: 적용기준 해당함
                </Typography>
              </StyledTableCellWithoutLeftRight>
            </TableRow>
          </TableHead>
          <TableBody>
            {contentLabel.map(
              (content: {
                id: number;
                desc: string[];
                scores: number[];
                ids: number[];
              }) => (
                <TableRow>
                  <StyledTableCellWithoutLeftRight>
                    {content.desc.map((v, i) => (
                      <TableRow
                        sx={{
                          height: '48px',
                          lineHeight: '48px',
                          borderBottom:
                            i !== content.desc.length - 1
                              ? '1px solid lightgray'
                              : '',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            paddingLeft: '16px',
                            fontSize: '12px',
                            width: '82.6vw',
                            maxWidth: '1340px',
                            minWidth: '1088px',
                            fontWeight: 500,
                          }}
                        >
                          {v}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutLeftRight>
                  <StyledTableCellWithoutLeftRight>
                    {content.scores.map((score, i) => {
                      return (
                        <TableRow
                          sx={{
                            height: '48px',
                            textAlign: 'center',
                            borderBottom:
                              i !== content.desc.length - 1
                                ? '1px solid lightgray'
                                : '',
                          }}
                        >
                          <Box
                            sx={{
                              width: '130px',
                              height: '48px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Form.MuiTextField
                              disabled={disabled}
                              required={false}
                              type="number"
                              inputProps={{ min, max }}
                              value={
                                content.desc[i].includes('수술:') ? input1 : 0
                              }
                              {...register(`no05_0${content.ids[i]}`, {
                                onChange: e => {
                                  var value = parseInt(e.target.value, 10);

                                  let max = { score };

                                  if (value >= max.score) value = max.score;
                                  if (value < min) value = min;

                                  if (content.desc[i].includes('수술:'))
                                    setInput1(value);
                                },
                              })}
                            />
                          </Box>
                        </TableRow>
                      );
                    })}
                  </StyledTableCellWithoutLeftRight>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{ marginTop: '20px' }}
        >
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            {/* 합계: {total}점 */}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Contents4;
